export const MDAndersonLogo = '/ClientResources/Website/images/logos/mdanderson_logo.png'
export const MDAndersonUrl = 'http://www.mdanderson.org/cancernetwork'
export const OHGCINLogo = '/ClientResources/Website/images/logos/OHGCIN_Logo.jpg'
export const OHGCINText = 'Participates in the OhioHealth Clinically Integrated Network for enhanced care coordination and improved quality of care.'
